import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import getMatchLineupsByEventIdThunk from '../store/lineups/actions/getMatchLineupsDataByEventId';
import {MatchLineups} from '../utils/types';
import {AppState} from '../store/types';

/**
 * Return type of the useMatchLineups hook
 */
type UseMatchLineupsResult = [
  {loading: boolean, data?: MatchLineups, error?: string | boolean},
  {getMatchLineupsByEventId: typeof getMatchLineupsByEventIdThunk},
]

/**
 * Selects the 'matchLineupsSelector' state and sum it up into a referring object
 */
const matchLineupsSelector = (state: AppState) => ({
  loading: state.matchLineups.isFetching,
  data: state.matchLineups.data,
  error: state.matchLineups.didInvalidate ? state.matchLineups.error : false,
});

/**
 * Wraps up the business logic of selecting the 'matchLineups' state.
 */
const useMatchLineups = (): UseMatchLineupsResult => {
  const dispatch = useDispatch();
  const state = useSelector(matchLineupsSelector);

  const getMatchLineupsByEventId = useCallback((id: string) => dispatch(getMatchLineupsByEventIdThunk(id)), [dispatch]);

  return [state, {getMatchLineupsByEventId}];
};

export default useMatchLineups;
